
import { defineComponent } from "vue"
import CardPoolsIndex from "@/components/card_pools/Index.vue"

export default defineComponent({
  components: {
    CardPoolsIndex
  }
})
